"use client";

import { Vacancy } from "@entities/vacancy";
import { createRestDataProviderClient } from "@providers/data-provider/rest-data-provider.client";
import { HighlightedText } from "@shared/ui";
import { PinLocationIcon } from "@shared/ui/custom-icon";
import { getSlug, transformQueryParamsWithoutLocale } from "@shared/utils";
import { Skeleton } from "@ubud-ui/react-ui-kit";
import { useQuery } from "@tanstack/react-query";
import Link from "next/link";

type MicroVacancy = Vacancy;

export function MicroVacancyResult({ keyword, onClick }: { keyword: string; onClick: () => void }) {
  const restDataProviderClient = createRestDataProviderClient();

  const { data: result, isFetching } = useQuery<{ data: MicroVacancy[] }>({
    queryKey: ["header-search-micro-vacancies", keyword],
    queryFn: () =>
      restDataProviderClient.custom({
        url: transformQueryParamsWithoutLocale("/karirhub/v1/available-micro-vacancies", {
          limit: 3,
          keyword: keyword,
        }),
        method: "GET",
      }),
    enabled: true,
  });

  if (isFetching) {
    return (
      <div>
        <h4 className="p-3 font-bold text-lg">Lowongan mikro</h4>
        <div className="space-y-2 mt-1">
          {[1, 2, 3].map((it) => {
            return (
              <div className="rounded-lg relative h-10 overflow-hidden" key={it}>
                <Skeleton className="absolute w-full h-full bg-gray-200" />
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  if (result && result.data?.length <= 0) {
    return <></>;
  }

  return (
    <div>
      <h4 className="p-3 font-bold text-lg">Lowongan mikro</h4>
      <div>
        {result?.data?.map((it) => {
          return (
            <Link
              key={it.id}
              href={`/lowongan-dalam-negeri/lowongan-mikro/${getSlug(it.id, it.job?.title)}`}
              className="flex items-start hover:bg-gray-200 rounded-lg p-3 gap-3"
              onClick={onClick}
            >
              <div className="flex-1">
                <div className="font-semibold text-base">
                  <HighlightedText keyword={keyword} text={it.job?.title} />
                </div>
                {it.companyName && <div className="mt-1 text-sm">{it.job?.employer?.name}</div>}
                {it.job?.region && (
                  <div className="mt-2 text-xs flex items-start gap-1">
                    <PinLocationIcon className="size-3 min-w-3 mt-0.5" />
                    <span className="flex-1">{it.job?.region?.name}</span>
                  </div>
                )}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
